/**
 * @generated SignedSource<<3a9e071c11613622f25a1940927f96fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeDesignManagerModal_user$data = {
  readonly serviceId: string | null;
  readonly socialNetworks: ReadonlyArray<{
    readonly status?: string | null;
  } | null> | null;
  readonly tradeFirmDesignManagerProfile: {
    readonly accountType: string | null;
    readonly hasAccount: boolean | null;
  } | null;
  readonly " $fragmentType": "TradeDesignManagerModal_user";
};
export type TradeDesignManagerModal_user$key = {
  readonly " $data"?: TradeDesignManagerModal_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeDesignManagerModal_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeDesignManagerModal_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmDesignManagerProfileType",
      "kind": "LinkedField",
      "name": "tradeFirmDesignManagerProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasAccount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accountType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "socialNetworkNames",
          "value": "DESIGN_MANAGER"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "socialNetworks",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "type": "DesignManagerSocialNetworkType",
          "abstractKey": null
        }
      ],
      "storageKey": "socialNetworks(socialNetworkNames:\"DESIGN_MANAGER\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "a3bea0134d29871a67312b8996cbad2b";

export default node;
